import moment from "moment";
export default function formAPIDoctorFavVaccine({
  id,
  createddate,
  vaccinename,


}) {
  return Object.freeze({
    id,
    createddate,
    vaccinename,

  });
}